// src/design-system/Atoms/ShimmerEffect.tsx
import React from "react";
import { cn } from "@/utils/className";

function ShimmerEffect({
    className,
    ...props
}: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={cn("relative overflow-hidden rounded-md bg-muted", className)}
            {...props}
        >
            <div className="absolute inset-0 bg-shimmer animate-shimmer" />
        </div>
    );
}

export { ShimmerEffect };
